import { render, staticRenderFns } from "./Caption.vue?vue&type=template&id=10a33692&scoped=true"
import script from "./Caption.vue?vue&type=script&lang=js"
export * from "./Caption.vue?vue&type=script&lang=js"
import style0 from "./Caption.vue?vue&type=style&index=0&id=10a33692&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10a33692",
  null
  
)

export default component.exports